import { preloadRepository } from "../app/services/repository"
import { preloadProfile } from "../app/services/user"
import { DocumentListBody } from "./DocumentListBody"
import { DocumentListHeader } from "./DocumentListHeader"
import { DocumentListLayout } from "./documentListLayout"
import { DocumentListSidePanel } from "./DocumentListSidePanel"
import { DocumentListProvider } from "./useDocumentList"

interface Props {
  tab: "working" | "archived"
}

export function DocumentList(props: Props) {
  const { tab } = props

  preloadRepository()
  preloadProfile()

  return (
    <DocumentListProvider>
      <DocumentListLayout
        header={<DocumentListHeader tab={tab} />}
        body={<DocumentListBody tab={tab} />}
        sidePanel={<DocumentListSidePanel />}
      />
    </DocumentListProvider>
  )
}
